import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "primeicons/primeicons.css";
import { routes } from "../routes";
import { findMatchingRoute, handlePageBack } from "../utils/pageBack";

const PageBackButton = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const matched = findMatchingRoute(location.pathname, routes);

  if (!matched?.route?.showBack) {
    return null;
  }

  return (
    <div className="admin-page-back">
      <button
        type="button"
        className="admin-page-back__btn"
        onClick={() => handlePageBack(matched, location, navigate)}
      >
        <i className="pi pi-arrow-left" aria-hidden="true" />
        {t("common.back")}
      </button>
    </div>
  );
};

export default PageBackButton;
